import { AxiosMethods } from '@setvi/shared/enums';
import { axiosHelper } from '@setvi/shared/services';

import type { ActivityItem } from './types';

const ACTIVITY_ENDPOINT = '/api/v2.0/Analytics/activity';

/**
 * React Query mutation factory, used via plain `useMutation` rather than
 * `useSubscribedMutation`: a failed analytics post is not something to toast at
 * the user, and there is nothing to invalidate. The user is taken from the
 * session — never send a user id.
 */
export const postActivitiesMutation = () => ({
  mutationFn: (items: ActivityItem[]) =>
    axiosHelper({
      endpoint: ACTIVITY_ENDPOINT,
      method: AxiosMethods.POST,
      baseURL: process.env.ADMIN_API_BASE_URL,
      body: { Items: items }
    })
});

/**
 * Post while the page is going away (refresh, tab close, navigation). A normal
 * request is cancelled at that point; `keepalive` lets this one finish. It is
 * `fetch` rather than `sendBeacon` because the endpoint needs the auth header,
 * which a beacon cannot set. The body cap for keepalive is 64KB, which a batch
 * of at most 200 small rows stays well under.
 */
export const postActivitiesOnUnload = (items: ActivityItem[]) => {
  try {
    fetch(`${process.env.ADMIN_API_BASE_URL}${ACTIVITY_ENDPOINT}`, {
      method: 'POST',
      keepalive: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.token}`
      },
      body: JSON.stringify({ Items: items })
    }).catch(() => {
      // Nothing to do — the page is going away.
    });
  } catch {
    // Same.
  }
};
